import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const LeftArrow = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb485__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb485__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="m59.144 40.481 7.883-7.883a2.03 2.03 0 0 1 2.877.02c.781.78.758 2.002-.023 2.783L58.546 46.736a1.974 1.974 0 0 1-2.807 0L44.404 35.401c-.782-.78-.805-2.002-.024-2.783l.024-.024a2.031 2.031 0 0 1 2.854.005l7.886 7.886v-28.59c0-1.104.91-2.04 2.015-2.04 1.075 0 1.985.936 1.985 2.04v28.586Z"
              transform="rotate(90 43 9.856)"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
